// import { ErrorsDisplay } from 'components/ErrorsDisplay'
import { navigate } from 'hookrouter'
import { useForm } from 'hooks/useForm'
import React from 'react'
import { Button, Col, Form, Row } from 'react-bootstrap'
import { updateUser } from 'state/async_actions'
import { useAppContext } from 'state/context'
import { Model, User } from 'types'

type EditUserFormInputs = Exclude<User, keyof Model>

export const EditUserForm = () => {
  const [
    {
      user: { firstName, id, lastName, email, phoneNumber },
    },
    dispatch,
  ] = useAppContext()

  const [formUser, handleInputChange, handleSubmit] = useForm<
    EditUserFormInputs
  >(submittedInputs => {
    updateUser(dispatch, submittedInputs, id as number)
    navigate('/')
  })

  return (
    <>
      <Row>
        <Col>
          <h1>Update User Profile</h1>
          {/* <ErrorsDisplay /> */}
        </Col>
      </Row>
      <Row>
        <Col>
          <Form onSubmit={handleSubmit}>
            <Form.Group controlId="formFirstName">
              <Form.Label>First Name</Form.Label>
              <Form.Control
                onChange={handleInputChange}
                value={formUser.firstName || firstName || ''}
                name="firstName"
                type="text"
              />
            </Form.Group>
            <Form.Group controlId="formLastName">
              <Form.Label>Last Name</Form.Label>
              <Form.Control
                onChange={handleInputChange}
                value={formUser.lastName || lastName || ''}
                name="lastName"
                type="text"
                placeholder="Enter Last Name"
              />
            </Form.Group>
            <Form.Group controlId="formEmail">
              <Form.Label>Email Address</Form.Label>
              <Form.Control
                onChange={handleInputChange}
                value={formUser.email || email || ''}
                name="email"
                type="email"
                placeholder="Enter Email"
              />
            </Form.Group>
            <Form.Group controlId="formPhoneNumber">
              <Form.Label>Phone Number</Form.Label>
              <Form.Control
                onChange={handleInputChange}
                value={formUser.phoneNumber || phoneNumber || ''}
                name="phoneNumber"
                type="number"
                placeholder="Enter Phone Number"
              />
            </Form.Group>
            <Button variant="primary" value="Save Changes" type="submit">
              Save Profile
            </Button>
          </Form>
        </Col>
      </Row>
    </>
  )
}
